export const locale = {
    'APPROVAL': {
        'STATUS': {
            'APPROVED': 'Утверждено',
            'NOT_APPROVED': 'Не утверждено',
        }
    },
};